import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { from as fromPromise, Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { concatMap } from 'rxjs/operators';
import { OrderResendResponse, orderResendResponseDecoder } from '@trade-platform/ui-shared';

@Injectable()
export class OrderResendService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderResend(orderId: string, recipientId: string): Observable<OrderResendResponse> {
        return this.http
            .post<OrderResendResponse>(`${this.environment.api}orders/${orderId}/resend_email`, {
                recipientId
            })
            .pipe(concatMap(p => fromPromise(orderResendResponseDecoder.decodeToPromise(p))));
    }
}
